import React, {useEffect} from 'react';
import {useNavigate} from 'react-router';
import {useSnackbar} from 'notistack';
import {Container, Stack, Typography} from '@mui/material';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import DownloadIcon from '@mui/icons-material/Download';
import {useQuery} from '@tanstack/react-query';
import {useLoaderState} from '../../components/Loader.js';
import SCButton from '../../components/SCButton.js';
import {useQueryParam} from '../../util/react_hooks.js';
import api from '../../util/api.js';

const TarotmailSagieAddRound = ()=>{
    let [txnId] = useQueryParam('internaldealnumber');
    let [terminal] = useQueryParam('terminalnumber');
    let [email] = useQueryParam('UserEmail');
    let [uid] = useQueryParam('UID');
    let [token] = useQueryParam('Token');
    let [approvalNum] = useQueryParam('OriginalApprovalNumber');
    let [docNum] = useQueryParam('invNumber');
    let {enqueueSnackbar} = useSnackbar();
    let navigate = useNavigate();
    let {data, error, isLoading} = useQuery({
        queryKey: ['tarotmail_sagie_add_round', {
            txnId,
            terminal,
            email,
            uid,
            token,
            approvalNum,
            docNum,
        }],
        queryFn: ()=>api.tarotmail.sagieAddRound({
            txnId,
            terminal,
            email,
            uid,
            token,
            approvalNum,
            docNum,
        }),
        enabled: !!(txnId&&terminal&&email&&uid&&token&&approvalNum&&docNum),
    });
    useLoaderState(isLoading);
    useEffect(()=>{
        if (error)
            enqueueSnackbar('אירעה שגיאה', {variant: 'error'});
    }, [error]);
    if (!data)
        return null;
    return <Container>
      <Stack direction="column" alignItems="center" gap={2}
        marginBottom={8} marginTop={5}>
        <TaskAltIcon color="success" sx={{fontSize: 100}}/>
        <Typography variant="h3" textAlign="center">
          תודה על הרכישה
        </Typography>
        <Stack direction="row" flexWrap="wrap" gap={2} justifyContent="center" alignItems="center">
          <SCButton variant="outlined" text="הורדת קבלה"
            icon={<DownloadIcon/>}
            onClick={()=>window.open(data.docUrl)}/>
          <SCButton variant="contained" text="המשך לקבלת מסרים לשבוע הקרוב"
            icon={<ChevronLeftIcon/>}
            onClick={()=>{
                window.location.href = `/tarotmailindex/${data.sagieId}?tmaEmail=${data.customer?.email}&tmaName=${data.customer?.name}`;
            }}/>
        </Stack>
      </Stack>
    </Container>;
};

export default TarotmailSagieAddRound;
